import { createContext } from 'react';

const AgentsContext = createContext();

export default AgentsContext;